import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import OrderSearchGrid from '../../../features/cfi/order-search-grid/components/OrderSearchGrid';
import {useSearchParams} from 'react-router-dom';

export default function OrderSearchPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Order Search')
	}, [pageTitle]);

	let [searchParams] = useSearchParams();

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<OrderSearchGrid
					searchField={searchParams.get("searchField")!}
					searchText={searchParams.get("searchText")!}
				/>
			</div>
		</React.Fragment>
	)
} 
